// ============================================================
// ChartCard Component
// ============================================================
// A wrapper for charts to provide standard widget styling.

import { Box, Typography } from '@mui/material';
import { WidgetContainer } from './WidgetContainer';
import { tokens } from '@/theme/tokens';

export function ChartCard({ title, children, height = 300, action }) {
  return (
    <WidgetContainer title={title} action={action}>
      <Box sx={{ height, width: '100%', mt: 2 }}>
        {children}
      </Box>
    </WidgetContainer>
  );
}
